import { render, staticRenderFns } from "./Unidade.vue?vue&type=template&id=0f26ab7d&scoped=true"
import script from "./Unidade.vue?vue&type=script&lang=js"
export * from "./Unidade.vue?vue&type=script&lang=js"
import style0 from "./Unidade.vue?vue&type=style&index=0&id=0f26ab7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f26ab7d",
  null
  
)

export default component.exports